import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { AuthContext } from '@dashboard/context/AuthContext';

const propTypes = {
  logout: PropTypes.func.isRequired,
};

export default class Logout extends Component {
  static contextType = AuthContext;

  componentDidMount() {
    const { logout } = this.context;

    logout();
  }

  render() {
    return <div>logging out..</div>;
  }
}

Logout.propTypes = propTypes;
